<template>
   <div class="menuadmin">
        <div class="menu-mobile menu-activated-on-click">
          <div class="menu-and-user">
            <ul class="main-menu">
            <li class="sub-header" v-if="isCredenciado">
              <span>Perfil Credenciado</span>
            </li>
            <li class="has-sub-menu" v-if="isCredenciado">
              
              <router-link v-for="menu in menuCredenciado" :key="menu.title" :to="menu.to">
                <div class="icon-w">
                  <div :class="menu.icon"></div>
                </div>
                <span v-text="menu.title"></span>
              </router-link>
              
              <router-link v-if="isAdmin" :to="{name: 'TipoRegistroForm'}">
                <div class="icon-w">
                  <div class="fa fa-id-card"></div>
                </div>
                <span>Registros Profissionais</span>
              </router-link>

              <router-link v-if="isAdmin" :to="{name: 'drAcheiDepoimento'}">
                <div class="icon-w">
                  <div class="fa fa-comment"></div>
                </div>
                <span>Depoimentos</span>
              </router-link>

              <router-link v-if="isAdmin" :to="{name: 'planos'}">
                <div class="icon-w">
                  <div class="fa fa-file-contract"></div>
                </div>
                <span>Planos</span>
              </router-link>
            </li>
          
          <li class="sub-header" v-if="isCorpoClinico">
              <span>Corpo Clínico</span>
            </li>
            <li class=" has-sub-menu" v-if="isCorpoClinico">
              <router-link v-for="menu in menuCorpoClinico" :key="menu.title" :to="menu.to">
                <div class="icon-w">
                  <div :class="menu.icon"></div>
                </div>
                <span v-text="menu.title"></span>
              </router-link>
          </li>

          <li class="sub-header" v-if="isPaciente">
            <span>Pacientes</span>
          </li>
          <li class=" has-sub-menu" v-if="isPaciente">
            <router-link v-for="menu in menuPaciente" :key="menu.title" :to="menu.to">
              <div class="icon-w">
                <div :class="menu.icon"></div>
              </div>
              <span v-text="menu.title"></span>
            </router-link>
          </li>
            
          </ul>
             
          </div>
        </div>
        <!--------------------
        END - Mobile Menu
        --------------------><!--------------------
        START - Main Menu
        -------------------->
        <div class="menu-w menu-position-side menu-side-left menu-layout-compact sub-menu-style-over sub-menu-color-bright selected-menu-color-light menu-activated-on-hover menu-has-selected-link">
        
        <div class="user-intro">
            <div class="avatar">
                <a v-if="isAdmin || isCredenciado" style="cursor: pointer" @click="openModalUpload"
                  title="Mudar Logo da Unidade">
                  <imagem-rede :nomeRede="rede.nomeRede || '0'"></imagem-rede>
                </a>
                <imagem-rede v-else :nomeRede="rede.nomeRede || '0'"></imagem-rede>
            </div>
            <div class="user-intro-info">
                <h5 class="user-name" style="overflow: hidden;width: 200px">
                    {{ rede.nomeRede }}
                </h5>
                <div class="user-sub" v-if="rede.cidade">
                    {{ rede.cidade }}, {{ rede.uf}}
                </div>
            </div>
        </div>
          <list-rede-admin placeholder="Informe a rede" v-if="user.role === 'Administrador'" ></list-rede-admin>
          <ul class="main-menu border-bottom">
            <li class="sub-header">
              <span>Principal</span>
            </li>
            <li class="">
            <router-link :to="{name: 'HomeAdmin'}">
                <i class="fas fa-home"></i><span>Home</span>
            </router-link>
            </li>
          </ul>
          <ul class="main-menu">
            <li class="sub-header" v-if="isCredenciado && rede._id">
              <span>Perfil Credenciado</span>
            </li>
            <li class="has-sub-menu" v-if="isCredenciado && rede._id">
              
              <router-link v-for="menu in menuCredenciado" :key="menu.title" :to="menu.to">
                <div class="icon-w">
                  <div :class="menu.icon"></div>
                </div>
                <span v-text="menu.title"></span>
              </router-link>
              
              
            </li>
          <li class="sub-header" v-if="isAdmin">
              <span>Administrador (GrupoSin)</span>
            </li>
             <li class="has-sub-menu" v-if="isAdmin">
               <router-link v-if="isAdmin" :to="{name: 'TipoRegistroForm'}">
                <div class="icon-w">
                  <div class="fa fa-id-card"></div>
                </div>
                <span>Registros Profissionais</span>
              </router-link>
              <router-link v-if="isAdmin" :to="{name: 'drAcheiDepoimento'}">
                <div class="icon-w">
                  <div class="fa fa-comment"></div>
                </div>
                <span>Depoimentos</span>
              </router-link>

              <router-link v-if="isAdmin" :to="{name: 'planos'}">
                <div class="icon-w">
                  <div class="fa fa-file-contract"></div>
                </div>
                <span>Planos</span>
              </router-link>
             </li>
          <li class="sub-header" v-if="isCorpoClinico && rede._id">
              <span>Corpo Clínico</span>
            </li>
            <li class=" has-sub-menu" v-if="isCorpoClinico && rede._id">
              <router-link v-for="menu in menuCorpoClinico" :key="menu.title" :to="menu.to">
                <div class="icon-w">
                  <div :class="menu.icon"></div>
                </div>
                <span v-text="menu.title"></span>
              </router-link>
          </li>

          <li class="sub-header" v-if="isPaciente">
            <span>Pacientes</span>
          </li>
          <li class=" has-sub-menu" v-if="isPaciente">
            <router-link v-for="menu in menuPaciente" :key="menu.title" :to="menu.to">
              <div class="icon-w">
                <div :class="menu.icon"></div>
              </div>
              <span v-text="menu.title"></span>
            </router-link>
          </li>
            
          </ul>
        </div>
   </div>
</template>
<script>
import ImagemRede from '@/components/shared/ImagemRede'
import ListRedeAdmin from '@/components/shared/listRedeAdmin'
import eventBus from '@/event-bus'

export default {
  components: {
    ImagemRede,
    ListRedeAdmin
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    isCredenciado () {
      return this.$store.getters.user.role === 'AdmRede' || this.$store.getters.user.role === 'AdminRede' || this.$store.getters.user.role === 'Administrador' || this.$store.getters.user.role === 'Atendente' || this.$store.getters.user.role === 'ATENDENTE'
    },

    isPaciente () {
      return this.$store.getters.user.role === 'Paciente'
    },

    isCorpoClinico () {
      return this.$store.getters.user.role === 'CorpoClinico'
    },
    isAdmin () {
      return this.$store.getters.user.role === 'Administrador'
    },
    isAtendente () {
      return this.$store.getters.user.role === 'ATENDENTE'
    },
    rede () {
      return this.$store.getters.rede || {}
    },
    utilizaAgendamento () {
      return this.$store.getters.rede && this.$store.getters.rede.agendamento
    },
    menuCredenciado () {
      if (this.isAtendente) {
        return this.utilizaAgendamento ? this.menuAtendenteAgendamento : this.menuAtendenteSemAgendamento
      }
      return this.utilizaAgendamento ? this.menuCredenciadoAgendamento : this.menuCredenciadoSemAgendamento
    }
  },
  data () {
    return {
      menuCredenciadoSemAgendamento: [
        {icon: 'fas fa-book', title: 'Dados do credenciado', to: {name: 'PageDadosCredenciado'}},
        {icon: 'fas fa-user-md', title: 'Cadastro Profissional', to: {name: 'PageCadastroProfissionalList'}},
        {icon: 'fas fa-file-alt', title: 'Prontuários', to: {name: 'PageProntuario'}},
        {icon: 'fas fa-file-invoice-dollar', title: 'Financeiro', to: {name: 'FinanceiroForm'}},
        {icon: 'fas fa-credit-card', title: 'Dr.Achei Card', to: {name: 'PageValidacaoCartaoSinsaude'}},
        {icon: 'fas fa-ticket-alt', title: 'Voucher DrAchei', to: {name: 'PageValidacaoVoucherDrAchei'}},
        {icon: 'fas fa-user', title: 'Usuário Atendente', to: {name: 'usuarioAtendente'}}
      ],
      menuCredenciadoAgendamento: [
        {icon: 'fas fa-book', title: 'Dados do credenciado', to: {name: 'PageDadosCredenciado'}},
        {icon: 'fas fa-user-md', title: 'Cadastro Profissional', to: {name: 'PageCadastroProfissionalList'}},
        {icon: 'fas fa-calendar', title: 'Agendamentos', to: {name: 'PageAgendamento'}},
        {icon: 'fas fa-file-alt', title: 'Prontuários', to: {name: 'PageProntuario'}},
        {icon: 'fas fa-file-invoice-dollar', title: 'Financeiro', to: {name: 'FinanceiroForm'}},
        {icon: 'fas fa-id-card', title: 'Dr.Achei Card', to: {name: 'PageValidacaoCartaoSinsaude'}},
        {icon: 'fas fa-ticket-alt', title: 'Voucher Dr.Achei', to: {name: 'PageValidacaoVoucherDrAchei'}},
        {icon: 'fas fa-user', title: 'Usuário Atendente', to: {name: 'usuarioAtendente'}}
      ],
      menuAtendenteSemAgendamento: [
        {icon: 'fas fa-file-alt', title: 'Prontuários', to: {name: 'PageProntuario'}},
        {icon: 'fas fa-card', title: 'Dr.Achei Card', to: {name: 'PageValidacaoCartaoSinsaude'}},
        {icon: 'fas fa-ticket-alt', title: 'Voucher Dr.Achei', to: {name: 'PageValidacaoVoucherDrAchei'}}
      ],
      menuAtendenteAgendamento: [
        {icon: 'fas fa-calendar', title: 'Agendamentos', to: {name: 'PageAgendamento'}},
        {icon: 'fas fa-file-alt', title: 'Prontuários', to: {name: 'PageProntuario'}},
        {icon: 'fas fa-id-card', title: 'Dr.Achei Card', to: {name: 'PageValidacaoCartaoSinsaude'}},
        {icon: 'fas fa-ticket-alt', title: 'Voucher Dr.Achei', to: {name: 'PageValidacaoVoucherDrAchei'}}
      ],
      menuCorpoClinico: [
        {icon: 'fas fa-file-alt', title: 'Prontuários', to: {name: 'PageProntuario'}},
        {icon: 'fas fa-file-alt', title: 'Avaliações', to: {name: 'PageDadosCredenciado'}},
        {icon: 'fas fa-file-alt', title: 'Agendamentos', to: {name: 'PageAgendamento'}},
        {icon: 'fas fa-file-alt', title: 'Meus Dados', to: {name: 'PageProfissionalAutenticado'}}
      ],
      menuPaciente: [
        {icon: 'fas fa-calendar', title: 'Meus Prontuários', to: {name: 'PageDadosCredenciado'}},
        {icon: 'fas fa-calendar', title: 'Meus Agendamentos', to: {name: 'PageAgendamento'}},
        {icon: 'fas fa-calendar', title: 'Avaliações', to: {name: 'PageDadosCredenciado'}},
        {icon: 'fas fa-calendar', title: 'Financeiro', to: {name: 'PageDadosCredenciado'}}
      ]
    }
  },

  methods: {
    openModalUpload () {
      eventBus.$emit('openModal', 'modalUploadLogo')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/MenuAdmin.vue